import api from "@/utils/axios";

/**
 * GET all document groups
 * optional filters:
 *   - section_id
 *   - status
 */
export const getAllDocumentGroups = (params = {}) =>
    api.get("/api/document-groups", { params });

/**
 * GET document group by section ID
 * supports pagination + filters
 *
 * example request:
 * /api/document-groups/section/15?page=1&limit=10
 */
export const getDocumentGroupsBySectionId = (sectionId, params = {}) =>
    api.get(`/api/document-groups/section/${sectionId}`, { params });

/**
 * GET a single document group
 */
export const getDocumentGroupById = (id) =>
    api.get(`/api/document-groups/${id}`);

/**
 * CREATE a document group
 */
export const createDocumentGroup = (payload) =>
    api.post("/api/document-groups", payload);

/**
 * UPDATE document group
 */
export const updateDocumentGroup = (id, payload) =>
    api.put(`/api/document-groups/${id}`, payload);

/**
 * DELETE (archive) document group
 */
export const deleteDocumentGroup = (id) =>
    api.delete(`/api/document-groups/${id}`);